import { useMemo } from "react";
import type { DocInfo, FileItem } from "@services/api";
import { Card, Typography, Space } from "antd";
import DownloadButton from "./DownloadButton";

const { Title } = Typography;

interface Props {
  title: string;
  docType: string;
  docs?: DocInfo[];
  className?: string;
  icon?: React.ReactNode;
}

export default function DocCard({
  title,
  docType,
  docs,
  className,
  icon,
}: Props) {
  const docFiles: FileItem[] = useMemo(() => {
    const doc = docs?.find((d) => d.docType === docType);
    const files = doc?.files ?? [];
    return files.filter(
      (f): f is FileItem =>
        Boolean(f && typeof f.fileId === "string" && f.fileId.trim())
    );
  }, [docs, docType]);

  if (!docFiles.length) return null;

  const isMultiple = docFiles.length > 1;

  return (
    <Card className={className} bordered bodyStyle={{ padding: 20 }}>
      <div style={{ display: "flex", gap: 16 }}>
        {icon && (
          <div
            style={{
              alignSelf: "stretch",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              paddingRight: 8,
            }}
          >
            {icon}
          </div>
        )}

        {/* Контент */}
        <div style={{ flex: 1 }}>
          <Space align="center" size={8} style={{ marginBottom: 8 }}>
            <Title level={5} style={{ margin: 0 }}>{title}</Title>
          </Space>

          <Space direction="vertical" size={12} align="start" style={{ width: "100%" }}>
            {docFiles.map((file) => (
              <DownloadButton
                key={file.fileId}
                file={file}
                type="primary" ghost
                label={isMultiple ? `Скачать - ${file.fileName || "Документ"}` : "Скачать"}
                aria-label={
                  isMultiple ? `Скачать файл ${file.fileName || "Документ"}` : "Скачать файл"
                }
              />
            ))}
          </Space>
        </div>
      </div>
    </Card>
  );
}
